<template>
  <div class="w-100 px-1">
    <!-- Loop de dropdowns-->
    <div class="w-100 wrapper-tags" v-for="item in selectedItems" :key="item.id">
      <div
        class="btn btn-outline-lightPrimary2 border-primary btn-small lspace-none btn-tags-light font-ARB text-start text-lightGray4 d-flex align-items-center py-2 mb-2"
        @click="removeItem(item)">
        <span class="ico-less bg-primary d-flex justify-content-center align-items-center border-right border-primary">
          <svg viewBox="0 0 25.548 1">
            <path d="M0,0V25.548" transform="translate(0 0.5) rotate(-90)" fill="none" stroke="#ffffff"
              stroke-width="1" />
          </svg>
        </span>
        <span>{{ item[trackBy] }}</span>
      </div>
    </div>

    <!-- Dropdown con opcion seleccionada -->
    <div class="wrapper-select-search custom-plus w-100 d-flex align-items-center position-relative mb-4">
      <button @click="toggleDropdown" class="clasic2-select">
        <input type="text" v-model="searchQuery" :placeholder="computedPlaceholder" @input="filterOptions"
          class="input-multiselect font-A16"/><div class="position-absolute select-icon" :class="{optionsOpen: dropdownOpen }"></div>
      </button>
      <div v-if="dropdownOpen" class="containerList multiselect">
        <ul class="optionsList p-0">
          <li v-for="option in filteredOptions" :key="option.id" @click="selectItem(option)"
            class="option font-Pr" tabindex="0">
            {{ option[trackBy]}}
          </li>
        </ul>
      </div>
      <div class="ico ico-remate">
        <span>
          <svg viewBox="0 0 25.548 25.548">
            <g transform="translate(-8.412 -7.99)">
              <path d="M309.391,0V25.548" transform="translate(-288.205 7.99)" fill="none" stroke="#008561"
                stroke-width="1" />
              <path d="M0,0V25.548" transform="translate(8.412 20.797) rotate(-90)" fill="none" stroke="#008561"
                stroke-width="1" />
            </g>
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['options', 'selectedItems', 'placeholder', 'trackBy'],
  data() {
    return {
      searchQuery: '',
      dropdownOpen: false,
      filteredOptions: []
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      if (this.dropdownOpen) {
        this.filterOptions();
      }
    },
    filterOptions() {
      this.filteredOptions = this.options.filter(option =>
        option[this.trackBy].toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    selectItem(item) {
      const index = this.selectedItems.findIndex(selectedItem => selectedItem.id === item.id);
      if (index === -1) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems.splice(index, 1);
      }
      this.searchQuery = '';
      this.dropdownOpen = false;
    },
    removeItem(item) {
      const index = this.selectedItems.findIndex(selectedItem => selectedItem.id === item.id);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
      }
    }
  },
  computed: {
    computedPlaceholder() {
      return `Agregar ${this.placeholder}`;
    },
  }
}
</script>
